import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import {computed, watch} from "vue";
import {useRoute} from "vue-router";
import {AEditor} from "@/views/editor/service/editor";
import CheckSquare from "@/views/share/CheckSquare.vue";
import {CardPreview} from "@/model/materials/card_preview";


export default /*@__PURE__*/_defineComponent({
  __name: 'DrawerCardSelector',
  props: {
    open: { type: Boolean }
  },
  emits: ['on-pick', 'update:open'],
  setup(__props: any, { emit: __emit }) {

const editor = useRoute().meta.editor as AEditor;
const emit = __emit
const props = __props;
const open = computed({get: () => props.open, set: (v) => emit('update:open', v)})

watch(open, o => {
  if (o) editor.material.cards.loadPage(1, 12)
})

const onCheck = (c: boolean, cp: CardPreview) => {
  if (c) {
    emit('on-pick', cp.data)
    open.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, _mergeProps({
    title: "选择卡片",
    placement: "right",
    width: "716px",
    "destroy-on-close": ""
  }, _ctx.$attrs, {
    open: open.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event))
  }), {
    default: _withCtx(() => [
      _createVNode(_component_a_list, {
        "data-source": _unref(editor).material.cards.cards,
        grid: {gutter: [16,0],column:3},
        pagination: {defaultPageSize:12,showSizeChanger:false,onChange: (a,b) => _unref(editor).material.cards.loadPage(a,b)}
      }, {
        renderItem: _withCtx(({item}) => [
          _createVNode(_component_a_list_item, null, {
            default: _withCtx(() => [
              _createVNode(CheckSquare, {
                check: false,
                "onUpdate:check": ($event: any) => (onCheck($event,item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_spin, {
                    spinning: item.active.loading
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_flex, {
                        vertical: "",
                        justify: "between-space",
                        class: "card"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: item.active.header,
                            alt: ""
                          }, null, 8, _hoisted_1),
                          _createVNode(_component_a_flex, {
                            style: _normalizeStyle({backgroundImage:`url(${item.active.content})`}),
                            class: "card__body",
                            align: "center",
                            justify: "center"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.active.loading ? '加载中' : '演示内容'), 1)
                            ]),
                            _: 2
                          }, 1032, ["style"]),
                          _createElementVNode("img", {
                            src: item.data.footer_image_url,
                            alt: ""
                          }, null, 8, _hoisted_2)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["spinning"])
                ]),
                _: 2
              }, 1032, ["onUpdate:check"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["data-source", "pagination"])
    ]),
    _: 1
  }, 16, ["open"]))
}
}

})